var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.position)?_c('LMarker',{attrs:{"icon":_vm.icon,"lat-lng":[_vm.position.latitude, _vm.position.longitude]}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }